import { render } from "./support_project.vue?vue&type=template&id=0ba729f0"
import script from "./support_project.vue?vue&type=script&lang=js"
export * from "./support_project.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__